import React, { useState } from 'react';
import { Card, Modal, Row } from 'antd';
import DF from 'DisplayFramework';

import FormInput from 'components/FormInput';
import AssetUpload from 'components/AssetUpload';
import SaveButton from 'components/SaveButtonTabsTop';
import { indexBy } from 'utils/utils2';
import ImagePreviw from './ImagePreview';
import ButtonOperation from 'components/ButtonOperation';

type MarketingLabelDetailProps = {
  visible: boolean;
  onSave: () => void;
  form: any;
  fieldName: string;
  _record: any;
  onCancel: any;
  catalogid: number;
  refetch: any;
  objectreference: string;
};

const UploadPictureAssetOptions = ({
  visible,
  onSave,
  form,
  fieldName,
  _record,
  onCancel,
  catalogid,
  refetch,
  objectreference,
}: MarketingLabelDetailProps) => {
  const NEW_CATALOG_OPTION_ID = -1;

  const [isEdited, setisEdited] = useState(false);
  return (
    <DF.Provider pagcode="marketinglabeldetail">
      <Modal
        visible={visible}
        onCancel={onCancel}
        width={1200}
        destroyOnClose
        footer={null}
      >
        <Card>
          <div className="card-container">
            <Row justify="end">
              <ButtonOperation
                htmlType="button"
                onClick={() => {
                  setisEdited(!isEdited);
                }}
                comcode="edit"
                style={{ height: 60 }}
              />

              <SaveButton htmlType="submit" onClick={onSave} comcode="save" />
            </Row>
            <Row gutter={18}>&nbsp;</Row>

            <Row gutter={40}>
              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl"
                    display={false}
                  />
                )}
              </FormInput>

              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl2"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl2',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl2 === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl2"
                    display={false}
                  />
                )}
              </FormInput>
              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl3"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl3',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl3 === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl3"
                    display={false}
                  />
                )}
              </FormInput>

              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl4"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl4',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl4 === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl4"
                    display={false}
                  />
                )}
              </FormInput>

              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl5"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl5',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl5 === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl5"
                    display={false}
                  />
                )}
              </FormInput>

              <FormInput
                wrapperCol={{ span: 24 }}
                col
                lg={8}
                onlylabel="optpictureurl6"
              >
                {_record?.optid === NEW_CATALOG_OPTION_ID || isEdited ? (
                  <AssetUpload
                    simpleUpload
                    form={form}
                    catalogid={catalogid}
                    opid={_record.optid}
                    picid={1}
                    refetch={refetch}
                    namePath={[
                      fieldName,
                      indexBy(form.getFieldValue(fieldName), 'optid')[
                        _record.optid
                      ],
                      'optpictureurl6',
                    ]}
                    objectreference={objectreference}
                  />
                ) : _record?.optpictureurl6 === 'null' ? (
                  <span />
                ) : (
                  <ImagePreviw
                    fieldName={fieldName}
                    form={form}
                    _record={_record}
                    name="optpictureurl6"
                    display={false}
                  />
                )}
              </FormInput>
            </Row>
          </div>
        </Card>
      </Modal>
    </DF.Provider>
  );
};

export default UploadPictureAssetOptions;
